/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-08-19 16:08:09
 * @LastEditTime: 2020-08-07 18:32:17
 */

import { request } from "./api-require";

const API_URL = "/oms-operation-service/v1";
import { objAny } from "../common/common-interface";
export const getMonitorGunStatus = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/gun/status", data, config);
};

export const getMonitorPileGrid = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/pile/grid", data, config);
};

export const getMonitorPileData = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/pile/data", data, config);
};

export const getMonitorGunInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/gun/info", data, config);
};

//获取站下全部桩及枪的数量
export const getMonitorTotalPileGun = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/monitor/total/pile_gun", data, config);
};
export const getMerchantPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/merchant/page", data, config);
};

export const getMerchantDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/merchant/detail", data, config);
};
// 删除商户
export const delMerchant = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/merchant/del", data, config);
};
//

export const addMerchant = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/merchant/add", data, config);
};

export const updMerchant = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/merchant/upd", data, config);
};

export const getStaPage = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/page", data, config);
};

/**
 * 获取充电站详情
 */
export const getStaDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/detail", data, config);
};

// 新增站点
export const addSta = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/sta/add", data, config);
};
// 修改站点
export const updSta = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/sta/upd", data, config);
};

// 修改充电站状态
export const updStationStatus = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  config.method = "get";
  return request(API_URL + "/opr/sta/upd_station_status", data, config);
};
/**
 * 查询费率模板信息
 */
export const getFeeInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/fee/info", data, config);
};
/**
 *
 * @param data 查询站点电价列表
 * @param config
 */
export const getStaFeeDetails = (
  data = {},
  config: objAny = {}
): Promise<objAny> => {
  config.method = "get";
  return request(API_URL + "/opr/sta/fee/detail", data, config);
};
/**
 * 查询站点下拉列表,站点id 站点名称
 */
export const getOprStaList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/list", data, config);
};

/**
 *
 * @param data 删除站点费率
 * @param config
 */
export const delStaFee = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/delete_fee", data, config);
};

/**
 * 新增/修改充电站绑定费率模板
 */
export const bindStaFee = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/bind_fee", data, config);
};

// 站点已关联商户信息接口
export const getAssociatedSta = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/associated/sta", data, config);
};

// 站点取消关联商户接口
export const staUnbindMerchant = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/unbind/merchant", data, config);
};

// 站点关联商户接口
export const staBindMerchant = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/bind/merchant", data, config);
};

// 查询商户类型下拉列表
export const merchantListSimple = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/merchant/list_simple", data, config);
};

// 查询费率下拉列表,费率feePkId - 费率名称
export const getFeeList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/fee/list", data, config);
};
// 查询商户下站点列表
export const getMchStaList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/merchant/list", data, config);
};
// 获取运营商配置信息
export const getConfigInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/get_congif_info", data, config);
};
// 获取登录账户信息
export const getLoginInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/get_login_info", data, config);
};
// 首页 - 资产
export const getHomeStatAssets = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/assets", data, config);
};
// 首页 - 充电数据
export const getHomeStatChargeCurve = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  return request(API_URL + "/stat/charge_curve", data, config);
};
// 首页 - 充电枪状态
export const getHomeStatGunStatus = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/gun_status", data, config);
};
// 首页 - 创建的订单量
export const getHomeStatOrderCurve = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  return request(API_URL + "/stat/order_curve", data, config);
};
// 首页 - 充电站昨日排名
export const getHomeStatRanking = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  return request(API_URL + "/stat/sta_ranking", data, config);
};
// 首页 - 今日充电电量
export const getHomeStatTodayElec = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/today_elec", data, config);
};
// 首页 - 今日营收
export const getHomeStatTodayIncome = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/today_income", data, config);
};
// 首页 - 今日订单量
export const getHomeStatTodayOrders = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/today_orders", data, config);
};
// 首页 - 站点地图查询站点列表
export const getMapStaList = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  return request(API_URL + "/map/sta/list", data, config);
};
// 首页 - 站点地图查看站点信息
export const getMapStaInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/map/sta/info", data, config);
};
// 获取运营商信息
export const getOprInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/get_opr_info", data, config);
};
// GET查询运营商列表
export const getOprList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/list", data, config);
};
// 获取运营商系统头信息
export const getSysHeader = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sys_header", data, config);
};
// 获取运营商系统头信息
export const updCongifInfo = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/upd_congif_info", data, config);
};
// 修改
export const updOprInfo = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/upd_opr_info", data, config);
};
// 获取充电站---商户
export const getStaKvs = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/merchant/list", data, config);
};
// 获取充电站---运营商
// export const getStaKvs = (data = {}, config: objAny = {}) => {
//   return request(API_URL + "/stat/sta_kvs", data, config);
// };
// 获取充电桩
export const getPileKvs = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/pile_kvs", data, config);
};
// 获取商户
export const getMerKvs = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/mer_kvs", data, config);
};
//获取会员和电卡统计
export const getCardStatistics = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/card/statistics", data, config);
};

//获取会员和电卡统计
export const getCardPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/card/page", data, config);
};

//关联电卡
export const getCardBind = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/card/bind", data, config);
};

//取消关联电卡
export const getCardUnbind = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/card/unbind", data, config);
};

//电卡详情
export const getCardDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/card/detail", data, config);
};

//获取企业会员统计数据
export const getEntUserStatistics = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/ent_user/statistics", data, config);
};

//分页获取企业会员基本信息列表
export const getEntUserPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ent_user/page", data, config);
};

//分页获取企业会员基本信息列表
export const getEntUserUpd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ent_user/upd", data, config);
};

//分页获取企业会员基本信息列表
export const getEntUserNotExistSta = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/ent_user/not_exist_sta", data, config);
};

//站点配置
export const getEntUserConfigSta = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ent_user/config_sta", data, config);
};

//已添加站点
export const getEntUserAlreadyExistSta = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/ent_user/already_exist_sta", data, config);
};

//新增企业会员
export const getEntUserAdd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ent_user/add", data, config);
};

//查询费率下拉列表,费率feePkId - 费率名称
export const getOprFeeList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/fee/list", data, config);
};

//分页获取企业成员列表
export const getEntSubUserPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ent_sub_user/page", data, config);
};

//删企业成员列表
export const getEntSubUserDel = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/ent_sub_user/del", data, config);
};

//修改企业成员列表
export const getEntSubUserUpd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ent_sub_user/upd", data, config);
};

//新增企业成员列表
export const getEntSubUserAdd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ent_sub_user/add", data, config);
};
//首页弹出图表
export const getStatHourCurve = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/hour_curve", data, config);
};
//运营-统计数据
export const getOptData = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/opt/data", data, config);
};
//运营-图表数据
export const getOptChart = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/opt/chart", data, config);
};
//运营-表格数据
export const getOptGrid = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/opt/grid", data, config);
};
//运营-今日表格数据
export const getOptTodayChart = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/opt/today_chart", data, config);
};
//运营-今日统计数据
// export const getOptTodayData = (data = {}, config: objAny = {}) => {
//   config.method = "get";
//   return request(API_URL + "/stat/opt/today_data", data, config);
// };
//运营-今日统计数据
export const getOptTodayData = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/mch/today_data", data, config);
};
// 一号多冲
export const getMultiChargeList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/multicharge/page", data, config);
};
// 一号多冲-审核
export const auditMultiCharge = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/multicharge/audit_multiCharge", data, config);
};
//
//运营-充电桩键值对集合
export const getStatPileKvs = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/pile_kvs", data, config);
};
//公告信息分页列表
export const getOprNoticeInfoList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/oprNoticeInfo/page", data, config);
};
//系统公告分页列表
export const getOprNoticeInfoSystemList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/notice/info/system/page", data, config);
};
//分页查询意见
export const getFeedBackList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/feed/back/page", data, config);
};
//客户消息分页查询
export const getFeedBackContentList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/feed/back/page/content", data, config);
};
//反馈处理 (回复)
export const feedBackHandle = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/feed/back/handle", data, config);
};
//用户指南分页查询
export const getOprUserGuideArticle = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/user/guide/page", data, config);
};
//删除文章
export const delOprUserGuideArticle = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/user/guide/delete", data, config);
};
//新增文章
export const addOprUserGuideArticle = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/user/guide/add", data, config);
};
//修改文章
export const upOprUserGuideArticle = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/user/guide/update", data, config);
};
//目录名称列表
export const getOprUserGuideMenuAll = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/directory/management/list", data, config);
};
//目录管理分页查询
export const getOprUserGuideMenuList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/directory/management/page", data, config);
};
//新增目录
export const addOprUserGuideMenu = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/directory/management/add", data, config);
};
//更新目录
export const upOprUserGuideMenu = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/directory/management/update", data, config);
};
//删除目录
export const delOprUserGuideMenu = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/directory/management/delete", data, config);
};
//财务统计-表格数据
export const getStatFinanceGrid = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/finance/grid", data, config);
};
//账户月度收支图表数据
export const getaAcctViewChart = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/acct_view/month/chart", data, config);
};
//账户月度收支表格数据
export const getaAcctViewGrid = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/acct_view/month/grid", data, config);
};
//运营-活跃人数表格数据
export const getOptActiveGrid = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/stat/opt/active/grid", data, config);
};
//充电枪健值对集合
export const getStatGunKvs = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/gun_kvs", data, config);
};

//分页获取充电站报表信息
export const getOprReportStaPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/report/charge/sta", data, config);
};
//分页获取充电桩报表信息
export const getOprReportPilePage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/report/charge/pile", data, config);
};
//分页获取渠道报表信息
export const getOprReportChannelPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/report/channel", data, config);
};
//分页获取电卡报表信息
export const getOprReportChargePage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/report/charge/card", data, config);
};
//分页获取企业报表信息
export const getOprReportConnectPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/report/enterprise", data, config);
};
//分页查询公告内容
export const getNoticeList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/notice/info/page/notice", data, config);
};
//删除公告内容
export const delNotice = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/notice/info/delete/station/notice", data, config);
};
//添加站点公告内容
export const addNotice = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/notice/info/add/station/notice", data, config);
};
//添加系统公告内容
export const addWxNotice = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/notice/info/add/system/notice", data, config);
};

//删除公告内容
export const oprStaDel = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/del", data, config);
};
//分页查询优惠券模板
export const getCouponList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/coupon/template/page", data, config);
};
//新增优惠券模板
export const addCoupon = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/coupon/template/add", data, config);
};
//修改优惠券模板
export const updateCoupon = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/coupon/template/update", data, config);
};
//优惠券模板详情
export const getCouponDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/coupon/template/detail", data, config);
};
//审核优惠券
export const auditCoupon = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/coupon/template/audit", data, config);
};
//审核优惠券
export const delCoupon = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/coupon/template/delete", data, config);
};
//优惠券及单次发放数量集合
export const getTemplateCouponList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/coupon/template/coupon/list", data, config);
};
//分页查询营销活动
export const getCampaign = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/campaign/page", data, config);
};
//新增营销活动
export const addCampaign = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/campaign/add", data, config);
};
//修改营销活动
export const updateCampaign = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/campaign/update", data, config);
};
//营销活动详情
export const getCampaignDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/campaign/detail", data, config);
};
//审核营销活动
export const auditCampaign = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/campaign/audit", data, config);
};
//停用营销活动
export const stopCampaign = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/campaign/block/up", data, config);
};
//获取当前运营商所有站点集合
export const getCampaignStationList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/campaign/station/list", data, config);
};
//分页查询用户优惠券
export const getUserCoupon = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/user/coupon/page", data, config);
};
//站点提交审核
export const submitApplications = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/submit_applications", data, config);
};
//站点审核
export const auditApplications = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/audit_applications", data, config);
};
//维护记录
export const getStaMaintenanceRecord = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/maintenance_record", data, config);
};
//现场调试
export const fieldDebugging = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/field_debugging", data, config);
};
//费率审核
export const auditFeeApplications = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/fee/audit_fee_applications", data, config);
};
//修改操作密码
export const modifyOperation = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/modify_operation", data, config);
};
//查询标签信息
export const getTagList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/tag/list", data, config);
};

//新增标签信息
export const addTag = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/tag/insert", data, config);
};

//删除标签信息
export const delTag = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/tag/delete", data, config);
};
// 获取商户信息
export const getMerchantInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/merchant/detail", data, config);
};

// 首页--曲线图
export const getMerchantCurve = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/mch/curve", data, config);
};
// 首页--营收统计
export const getMerchantIncome = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/mch/income", data, config);
};
// 首页--结算信息
export const getMerchantSettlement = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/mch/settlement", data, config);
};
// 首页--今日统计数据
export const getMerchantTodayData = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/mch/today_data", data, config);
};
// 首页--设备利用率昨日排名
export const getUtilRanking = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/stat/mch/util_ranking", data, config);
};
// 首页--获取站点排名数据
export const getStaRanking = (data = {}, config: objAny = {}) => {
  config.method = "post";
  return request(API_URL + "/stat/opt/ranking", data, config);
};
//获取运营商配置信息
export const getCongifInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/get_congif_info", data, config);
};
//获取运营商配置信息
export const getOperBacklog = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/backlog/mch/detail", data, config);
};
// 电卡详情
export const getCardDetails = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/recharge_card/detail", data, config);
};
// 开卡
export const openCard = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/recharge_card/open_card", data, config);
};
// 获取验证码
export const getImgCode = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/recharge_card/img_code", data, config);
};
// 获取加密运营商编码
export const getByMchIdCustomerId = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/recharge_card/customerId", data, config);
};
// 读卡
export const readCard = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/recharge_card/read_card", data, config);
};
// 获取新开卡的卡号
export const getCardSerialNumber = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    API_URL + "/recharge_card/get_card_serial_number",
    data,
    config
  );
};
// 注销
export const cancelCard = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/recharge_card/cancel_card", data, config);
};
// 分页查询充电站费率追踪列表
export const getStaFeeTrailPage = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/sta/fee/trail/page", data, config);
};

// 查询邮箱是否已经注册和绑定卡
export const checkCardInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/recharge_card/checkCardInfo", data, config);
};
